import React from 'react'

import { ITank } from 'types'

interface IProps {
  tank: ITank
}

const LPG = ({ tank }: IProps) => {
  const info = tank.info
  let value = Math.round(parseFloat(info.value) * 100)

  if (value > 100) {
    value = 100
  } else if (value < 0) {
    value = 0
  }

  const top = -38
  const bot = 73
  const range = top - bot
  const fillh = (value / 100) * range * -1 + 24
  const y = (value / 100) * range + bot

  return (
    <svg viewBox="0 0 200 210">
      <g transform="translate(100,100)">
        <rect
          x={-45}
          y={80}
          width={90}
          height={30}
          rx={45}
          ry={10}
          fill="url(#lpgGradient)"
          strokeWidth="1px"
          stroke="#cfd0e1"
        />
        <ellipse cx={0} cy={70} rx={60} ry={15} fill="#fff" />
        <rect
          x={-60}
          y={-65}
          width={120}
          height={160}
          rx={60}
          ry={15}
          fill="url(#lpgGradient)"
          strokeWidth="1px"
          stroke="#cfd0e1"
        />
        <rect x={-50} y={-18.92} width={100} height={fillh} rx={55} ry={12} fill="url(#fillGradient)" />
        <ellipse cx={0} cy={y} rx={50} ry={12} fill="#81e0ff" />
        <rect
          x={-25}
          y={-95}
          width={50}
          height={40}
          rx={40}
          ry={10}
          fill="url(#lpgGradient)"
          strokeWidth="1px"
          stroke="#cfd0e1"
        />
        <text
          textAnchor="middle"
          fontSize="50px"
          fontWeight="bold"
          style={{ fill: 'rgb(130, 112, 102)' }}
          transform={`translate(${value < 10 ? -5 : value < 100 ? -10 : -13}, 25)`}
        >
          {value}
        </text>
        <text
          textAnchor="middle"
          fontSize="20px"
          fontWeight="bold"
          style={{ fill: 'rgb(130, 112, 102)' }}
          transform={`translate(${value < 10 ? 20 : value < 100 ? 30 : 38}, 10)`}
        >
          %
        </text>
      </g>
    </svg>
  )
}

export default LPG
